import { useEffect, useRef, useState } from 'react';

interface Props {
  message: string;
  visible: boolean;
  durationMs?: number;
  onUndo: () => void;
  onDismiss: () => void;
}

export function UndoToast({ message, visible, durationMs = 10000, onUndo, onDismiss }: Props) {
  const [remaining, setRemaining] = useState(durationMs);
  const dismissRef = useRef(onDismiss);
  dismissRef.current = onDismiss;

  useEffect(() => {
    if (!visible) return;
    setRemaining(durationMs);
    const start = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      if (elapsed >= durationMs) {
        clearInterval(interval);
        dismissRef.current();
      } else {
        setRemaining(durationMs - elapsed);
      }
    }, 100);
    return () => clearInterval(interval);
  }, [visible, durationMs]);

  if (!visible) return null;
  const secs = Math.ceil(remaining / 1000);

  return (
    <div className="undo-toast" role="status">
      <span>{message}</span>
      <button onClick={onUndo}>Undo ({secs}s)</button>
    </div>
  );
}
